import _ from 'lodash';
import {
    updateLeaveBarterSelectedOption,
    queryLeaveBarterConfig,
} from '../api/selectiongql';
import {
    LEAVEBARTER_UPDATE,
} from './types';

export const handleUpdateLeaveBarterOption = (
    {
        id, type, numberOfDays,
    },
    errorCallback,
    successCallback,
) => async (dispatch, getState) => {
    const state = getState();
    const {token} = state.config;
    const data = await updateLeaveBarterSelectedOption({
        leaveBarterId: id,
        numberOfDays,
        type,
        token,
    });
    if (data instanceof Error) {
        if (errorCallback) errorCallback(data);
    } else {
        // Get member new leave barter config results here
        let memberNewLeaveBarterConfig = await queryLeaveBarterConfig({
            token,
        });
        if (memberNewLeaveBarterConfig instanceof Error) {
            if (errorCallback) errorCallback(memberNewLeaveBarterConfig);
        } else {
            if (successCallback) successCallback();
            dispatch({
                type: LEAVEBARTER_UPDATE,
                payload: memberNewLeaveBarterConfig,
            });
        }
    }
};